const $filtersForm = $('[data-filters-form]');

export const initFiltersMenu = () => {
  /** This will close any filter that is open. */
  const closeFilterMenu = () => {
    $('[aria-haspopup]').attr('aria-expanded', 'false');
    $('[role="menu"]').removeClass('open').css('right', '');
  };

  /** Opens specified filter, closing any fiters already open. */
  const openFilterMenu = ($filter) => {
    closeFilterMenu();
    const $filterButton = $filter.find('[aria-haspopup]');
    $filterButton.attr('aria-expanded', 'true');

    // Use sheet for options on ZDS pages
    const { isZDS, isMobile } = zr.page.model;
    if (isZDS && isMobile) {
      const name = $filter.data('filter');
      const ele = $filterButton.get(0);
      const evt = new CustomEvent('mobileFilterTriggered', { detail: { name, filter: ele } });
      window.dispatchEvent(evt);
      return;
    }

    const $filterMenu = $filter.find('[role="menu"]');
    $filterMenu.addClass('open');

    // correct the menu position if it's overflowing the right side of the screen
    setTimeout(() => {
      const rect = $filterMenu[0]?.getBoundingClientRect();
      if (rect.right > (window.innerWidth || document.documentElement.clientWidth)) {
        $filterMenu.css('right', 0);
      }
    }, 0);

    // for horizontal scroll open subMenu on the good position
    if ($filter.closest('.horizontal_scroll').length > 0) {
      $filter.find('[role="menu"]').css('left', $filter[0].getBoundingClientRect().left);
    }
  };

  $filtersForm.on('click', '[data-filter] [aria-haspopup]', (event) => {
    const $filterToggle = $(event.target);
    const $filter = $filterToggle.closest('[data-filter]');

    if ($filterToggle.attr('aria-expanded') === 'false') {
      openFilterMenu($filter);
    } else {
      closeFilterMenu();
    }
  });

  $filtersForm.on('click', 'button', (event) => {
    const $buttonClicked = $(event.target);

    // Necessary for cross-browser blur events/keyboard controls.
    $(event.target).focus();

    // If we're about to submit the form, we want to disable the unneeded hidden input for this specific filter.
    if ($buttonClicked.attr('name')) {
      const $input = $filtersForm.find(`input[name="${$buttonClicked.attr('name')}"][type="hidden"]`);
      $input.attr('disabled', 'disabled');
    }
  });

  // Close filter when focus moves out of submenu. https://stackoverflow.com/a/60094794
  $filtersForm.on('blur', '[data-filter]', (event) => {
    const { isSerp, isZDS, isMobile } = zr.page.model;
    if (isSerp && isZDS && isMobile) {
      // On the new ZDS Serp design, a blur will always occur...
      return;
    }
    if (!event.currentTarget.contains(event.relatedTarget)) {
      closeFilterMenu();
    }
  });

  // Remove unselected class from tags layout filters:: if filter is not active
  $('.menu_wrap').each((index, record) => {
    const selectedValue = $(record).find('input[type=hidden]').val();
    if (selectedValue !== '' && selectedValue.indexOf('all') < 0) {
      $(record).find('button').removeClass('unselected');
    }
  });

  // Keyboard Controls
  $filtersForm.on('keydown', '[data-filter]', (event) => {
    const keyArrowDown = event.key === 'ArrowDown' || event.key === 'Down';
    const keyArrowUp = event.key === 'ArrowUp' || event.key === 'Up';
    const keyEscape = event.key === 'Escape' || event.key === 'Esc';

    if (!(keyArrowDown || keyArrowUp || keyEscape)) {
      return;
    }

    const $filter = $(event.target).closest('[data-filter]');
    const $filterToggle = $filter.find('[aria-haspopup]');
    const $filterButtons = $filter.find('button');

    const focusIndex = Array.prototype.indexOf.call($filterButtons, event.target);

    if (focusIndex < 0) {
      return;
    }

    if (keyEscape) {
      closeFilterMenu();
      $filterToggle.focus();
    }

    if (event.target === $filterToggle.get(0)) {
      if (keyArrowDown) {
        openFilterMenu($filter);
      } else if (keyArrowUp) {
        closeFilterMenu();
        event.preventDefault();
        return;
      }
    }

    if (keyArrowUp || keyArrowDown) {
      event.preventDefault();

      const offset = keyArrowUp ? -1 : 1;
      const btnIndex = (focusIndex + offset + $filterButtons.length) % $filterButtons.length;

      $filterButtons.get(btnIndex).focus();
    }
  });

  if (zr.page.model.isZDS) {
    // set min width of menus to the width of the button
    // doing this in JS because using position: relative on the .menu_wrap
    // breaks the menu (it gets hidden in the scroll container overflow)
    const filterItems = document.querySelectorAll('.filters .menu_wrap');
    filterItems.forEach((filterItem) => {
      const filterItemRect = filterItem?.getBoundingClientRect();
      const filterMenu = filterItem.querySelector('.submenu');
      filterMenu.style.minWidth = `${filterItemRect.width}px`;
    });
  }
};

export default initFiltersMenu;
